export default __webpack_public_path__ + "static/media/markopolo.1c4f3361.png";